import { useEffect } from "react";
import { useAppSelector } from "../../../Store";
import { ValueType } from "../../../Definitions";
import { useDispatch } from "react-redux";
import { selectAllMilestoneOptions, upsertMilestoneOptions } from "../../../Store/optionsHandlers/optionsCombinedReducer";
import { gql, useQuery } from "@apollo/client";
import { BasicQueryInfoInput } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";

const MILESTONE_OPTIONS_QUERY = gql`
  query MilestoneOptions($domain: String!, $input: BasicQueryInfoInput!) {
    milestone {
      info(domain: $domain, input: $input) {
        label: name
        id: milestone_id
        deleted
      }
    }
  }
`

interface MilestoneOptionsResult {
  milestone: {
    info: (ValueType & {deleted: boolean})[]
  }
}

export const useMilestoneOptions = () => {
  const farm = useAppSelector(({ activeData}) => activeData.farm) ?? "";

  const fetchTime = useAppSelector(({optionsState}) => {if ("lastFetched" in optionsState.milestoneOptions && typeof optionsState.milestoneOptions.lastFetched === "number") {return optionsState.milestoneOptions.lastFetched}})
  const dispatch = useDispatch();
  const reduxOptions = useAppSelector((state) => selectAllMilestoneOptions(state));
  const {data, loading} = useQuery<MilestoneOptionsResult, {domain: string, input: BasicQueryInfoInput}>(MILESTONE_OPTIONS_QUERY, {
   skip: !!reduxOptions.length || fetchTime !== undefined || (fetchTime && (Date.now()-fetchTime > 300000)),
    fetchPolicy: "no-cache",
    variables: {
      domain: farm,
      input: {fetchAmount: 500}
    }
  })

  useEffect(() => {
    if (!loading && data && !reduxOptions.length) {
      dispatch(upsertMilestoneOptions(data.milestone.info.filter((milestone) => !milestone.deleted)))
    }
  },[data, dispatch, loading, reduxOptions.length])

  return reduxOptions;
};
